import React from 'react';
import { LegalLayout } from '../components/legal/LegalLayout';
import { useLanguage } from '../contexts/LanguageContext';
export function PrivacyPolicy() {
  const {
    t
  } = useLanguage();
  const sections = t('legal.privacy.sections') || [];
  return <LegalLayout title={t('legal.privacy.title')} lastUpdated="October 24, 2024" data-id="element-215">
      <p data-id="element-216">{t('legal.privacy.intro')}</p>

      {sections.map((section: any, index: number) => <div key={index} data-id="element-217">
          <h2 data-id="element-218">{section.heading}</h2>
          {section.paragraphs.map((p: string, pIndex: number) => <p key={pIndex} data-id="element-219">{p}</p>)}
          {section.list && <ul data-id="element-220">
              {section.list.map((item: string, lIndex: number) => <li key={lIndex} data-id="element-221">{item}</li>)}
            </ul>}
        </div>)}
    </LegalLayout>;
}